module.exports = __webpack_public_path__ + "static/media/alwaysOnIcon.91e47331.svg";